import { render } from "./RulesModal.vue?vue&type=template&id=7d14f64c"
import script from "./RulesModal.vue?vue&type=script&lang=js"
export * from "./RulesModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__